'use client';
import { useState, useEffect } from 'react';

var e;
var TransitionStatus;
(e = TransitionStatus || (TransitionStatus = {})).ENTERED = "entered", e.ENTERING = "entering", e.EXITED = "exited", e.EXITING = "exiting";
function useTransition(e, n = 200) {
    let [i, a] = useState(e ? "entered" : "exited");
    return useEffect(()=>{
        a((t)=>e ? "entered" !== t ? "entering" : "entered" : "exited" !== t ? "exiting" : "exited");
        let t = setTimeout(()=>{
            a((e)=>{
                switch(e){
                    case "entering":
                        return "entered";
                    case "exiting":
                        return "exited";
                    default:
                        return e;
                }
            });
        }, n);
        return ()=>clearTimeout(t);
    }, [
        n,
        e
    ]), i;
}

export { TransitionStatus, useTransition };
